import React from 'react'
import { PlusLg } from 'react-bootstrap-icons'
import UnderlineTabs from '../../ProjectManager/Campaigns/CampaignsBrowseParts/UnderlineTabs'
import { CLIENT_PAGE_GUTTER } from '../../ProjectManager/Campaigns/CampaignsBrowseParts/clientPageLayout'

const BASE_TABS = [
  { id: 'timeline', label: 'Timeline' },
  { id: 'calendar', label: 'Calendar' },
]

export default function SharedClientPageHeader({ clientName, activeTab, onTabChange, onNewCalendarEntry, showSummaryTab }) {
  const tabs = showSummaryTab ? [{ id: 'summary', label: 'Summary' }, ...BASE_TABS] : BASE_TABS

  return (
    <header className="w-full shrink-0 bg-rb-grey dark:bg-rb-dark-mode-background">
      <div className={`${CLIENT_PAGE_GUTTER} pt-6 pb-0`}>
        <div className="flex w-full items-start justify-between gap-6">
          <h1 className="text-2xl font-bold dark:text-white">{clientName}</h1>
          {activeTab === 'calendar' && (
            <button
              type="button"
              className="flex h-9 shrink-0 items-center gap-1.5 rounded-lg bg-rb-green px-4 text-sm font-semibold text-white hover:bg-rb-green/90"
              onClick={onNewCalendarEntry}
            >
              <PlusLg aria-hidden />
              New Entry
            </button>
          )}
        </div>
        <UnderlineTabs
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={onTabChange}
          className="mt-6 border-b border-rb-widget-border dark:border-rb-dark-mode-lighter"
        />
      </div>
    </header>
  )
}
